﻿import { IComponent, Component, Inject, Input, Output } from "@fiqas/angular-utils";
import { IRoutingComponent, RouteConfig } from "@fiqas/ngcomponentrouter";
import { FIQAssist } from "../../app";
import { IDisposable } from "../../interfaces/general";
import { SaveDialog } from "./savedialog";
import { AuthenticationService } from "../../services/authenticationService";
import { AuthorizationService } from "../../services/authorizationService";

export abstract class ControlBase implements IComponent {
    constructor(
        protected saveDialog: SaveDialog,
        protected $rootRouter: ng.Router,
        protected $timeout: ng.ITimeoutService,
        protected authorizationService: AuthorizationService,
    ) {

    }

    public $onInit() {
    }

    public $onDestroy() {
    }

    /**
     * called to to determine whether a Component can be reused across Route Definitions that match the same type of Component, or whether to destroy and instantiate a new Component every time.
     */
    public $routerCanReuse(next?: angular.ComponentInstruction, prev?: angular.ComponentInstruction): ng.IPromise<boolean> | boolean {
        return true;
    }
    /**
     * called by the Router at the end of a successful navigation. Only one of $routerOnActivate and $routerOnReuse will be called depending upon the result of a call to $routerCanReuse.
     */
    public async $routerOnActivate(next?: angular.ComponentInstruction, prev?: angular.ComponentInstruction) {
         await this.authorizationService.roleLoaded;
        let a = next;
    }
    /**
     * called by the Router at the end of a successful navigation. Only one of $routerOnActivate and $routerOnReuse will be called depending upon the result of a call to $routerCanReuse.
     */
    public async $routeOnReuse(next?: angular.ComponentInstruction, prev?: angular.ComponentInstruction) {
         await this.authorizationService.roleLoaded;
        let b = next;
    }

    public async $routerCanDeactivate(next?: angular.ComponentInstruction, prev?: angular.ComponentInstruction) {
        if (this.isDirty) {
            return this.saveDialog.Save().then(result => {
                let res = result === SaveDialog.Discard;
                this.isDirty = res;
                return new Promise(resolve => {
                    this.$timeout(25).finally(() => resolve(res));
                });
            }).catch(() => { return false });
        }
        return true;
    }

    public static $canActivate = AuthorizationService.RoleCheck;

    public goHome() {
        this.$rootRouter.navigate(["Home"]);
    }

    public setErrorClass(element, classname: string) {
        angular.element(element[0].getElementsByClassName(classname).item(0)).addClass('error');
    }

    public clearErrorClass(element, classname: string) {
        angular.element(element[0].getElementsByClassName(classname).item(0)).removeClass('error');
    }

    public Title: string = '';
    public Title2: string = '';
    public Status: string = null;
    public activeMenuItem: string;
    public highlightMenuItem: string;

    public get isDirty(): boolean {
        return this.authorizationService.dirty;
    }
    public set isDirty(val: boolean) {
        this.authorizationService.dirty = val;
    }
}
